import React from 'react'
import Chat from './Chat'
import { useQuery, useMutation } from '@apollo/client'
import { QUERY, MUTATION } from '../../apollo'

function AskSupervision() {
  const { data } = useQuery(QUERY.USER_INFO)
  const userInfo = data?.userInfo

  const [updateMessages] = useMutation(MUTATION.UPDATE_MESSAGES, {
    onError: (error) => {
      console.log(error.graphQLErrors[0].message)
    },
    refetchQueries: [{ query: QUERY.USER_INFO }],
  })

  async function messenger(message) {
    try {
      await updateMessages({
        variables: {
          message,
        },
      })
    } catch (err) {
      console.log({ err })
    }
  }

  return userInfo ? (
    <Chat
      messages={userInfo.messages}
      sendMessage={messenger}
      placeholder="Drop us a Message…"
      username={userInfo.name}
      relativePosition
    />
  ) : null
}

export default AskSupervision
